export default {
  commonLayoutHeaderDeeplinkLogoLink: 'common-layout-header-deeplink-logo-link',
}
